var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { FlightButton, FlightSelect, FlightSelectMulti, FlightSnackbar } from '@flybits/design-system';
import React, { useCallback, useEffect, useState } from 'react';
import LocationHeaderIcon from '../images/LocationHeaderIcon';
import { mapBlockToRuleFrameProps, generateSubPredicateIndex } from './shared/helpers';
import RuleFrame from './shared/RuleFrame';
import { RB_SIDE_PANEL_THEMES, RuleBuilderSidePanel } from './shared/RuleBuilderSidePanel';
import ViewBoxLoader from './shared/ViewBoxLoader';
import { SAVE_LOCATION_STATUSES } from '../constants/types';
import GoogleMapWrapper from './ManageLocation/GoogleMapWrapper';
import { ManageLocation } from './ManageLocation/ManageLocation';
import { getConstraints } from '../utils/helpers';
var initLocationPayload = {
    name: '',
    address: '',
    shape: [[]],
    labels: [],
};
function LocationsList(renderProps) {
    var uiBlock = renderProps.uiBlock, updateUiBlock = renderProps.updateUiBlock, contextLabels = renderProps.contextLabels, _a = renderProps.locationProps, locations = _a.locations, googleMapAPIKey = _a.googleMapAPIKey, areLocationsWaiting = _a.areLocationsWaiting, onSaveLocation = _a.onSaveLocation, isLocationSaving = _a.isLocationSaving, hideAddNewLocationCTA = _a.hideAddNewLocationCTA;
    var _b = __read(useState([]), 2), locationsList = _b[0], setLocationsList = _b[1];
    var _c = __read(useState([]), 2), locationsForMultiSelect = _c[0], setLocationsForMultiSelect = _c[1];
    var _d = __read(useState([]), 2), labelsForAddNewLocation = _d[0], setLabelsForAddNewLocation = _d[1];
    var _e = __read(useState(false), 2), showError = _e[0], setShowError = _e[1];
    var _f = __read(useState(false), 2), isUniqueLocationNameError = _f[0], setUniqueLocationNameError = _f[1];
    var _g = __read(useState(false), 2), showLocationSnackbar = _g[0], setShowLocationSnackbar = _g[1];
    var _h = __read(useState(''), 2), locationSnackbarMessage = _h[0], setLocationSnackbarMessage = _h[1];
    var _j = __read(useState('error'), 2), locationSnackbarType = _j[0], setLocationSnackbarType = _j[1];
    function getAtLeastOneLocationSelected() {
        var atLeastOneLocationSelected = locationsList.some(function (location) { return location.isSelected === true; });
        if (!atLeastOneLocationSelected) {
            setShowError(true);
        }
        else {
            setShowError(false);
        }
    }
    function updateLocationsOnSearch(searchText) {
        setLocationsForMultiSelect(locationsList.filter(function (location) { return location.name.toLowerCase().includes(searchText.toLowerCase()); }));
    }
    function updateLocationsListUiBlock(selectedLocation) {
        var _locationsList = locationsList.map(function (location) {
            if (location.key === selectedLocation.key) {
                location.isSelected = !location.isSelected;
                selectedLocation.isSelected = location.isSelected;
            }
            return location;
        });
        var isExistingLocationNameRule = false;
        var locationNameConditions = uiBlock.rules.filter(function (locationNameCondition) {
            var locationRuleCtxVariable = locationNameCondition.ctxVariable;
            var locationRuleUidParts = locationRuleCtxVariable.split('.');
            var locationRuleKey = locationRuleUidParts[locationRuleUidParts.length - 1];
            if (locationRuleKey === selectedLocation.key) {
                isExistingLocationNameRule = true;
                // Remove de-selected location name from the ui block
                if (!selectedLocation.isSelected) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return true;
        });
        // Add new location names (if selected) to the ui block
        if (!isExistingLocationNameRule && selectedLocation.isSelected) {
            var ctxVariable = "".concat(uiBlock.ctxAttributeUid, ".").concat(selectedLocation.key);
            var locationRule = {
                ctxVariable: ctxVariable,
                parameterValues: [selectedLocation.key],
                value: 'true',
                attributeName: uiBlock.attributeName,
                nodeId: generateSubPredicateIndex(locationNameConditions, uiBlock.nodeId),
            };
            locationNameConditions.push(locationRule);
        }
        var updatedUiBlock = __assign(__assign({}, uiBlock), { rules: locationNameConditions });
        updateUiBlock(updatedUiBlock);
        setLocationsList(_locationsList);
        setLocationsForMultiSelect(_locationsList);
    }
    useEffect(function () {
        var e_1, _a, e_2, _b;
        var locationsList = locations.map(function (location) { return ({
            key: location.id,
            name: location.name,
            isSelected: false,
            isDisabled: false,
        }); });
        var labelsForAddNewLocation = [];
        var visitedLabels = {};
        locations.forEach(function (location) {
            var _a;
            (_a = location.labels) === null || _a === void 0 ? void 0 : _a.forEach(function (label) {
                if (!visitedLabels[label]) {
                    visitedLabels[label] = true;
                    labelsForAddNewLocation.push(label);
                }
            });
        });
        setLocationsList(locationsList);
        setLocationsForMultiSelect(locationsList);
        setLabelsForAddNewLocation(labelsForAddNewLocation);
        // While adding a new location list rule condition
        if (uiBlock.value === '' && uiBlock.operator === '') {
            updateUiBlock(__assign(__assign({}, uiBlock), { operator: 'boolEq' }));
            // For existing location list rule condition
        }
        else {
            var hasConstrainedSubBlock = false;
            try {
                for (var _c = __values(uiBlock.rules), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var rule = _d.value;
                    var isDeleteLocked = getConstraints(rule).isDeleteLocked;
                    if (isDeleteLocked)
                        hasConstrainedSubBlock = true;
                    var locationRuleUidParts = rule.ctxVariable.split('.');
                    var locationRuleId = locationRuleUidParts[locationRuleUidParts.length - 1];
                    try {
                        for (var locationsList_1 = (e_2 = void 0, __values(locationsList)), locationsList_1_1 = locationsList_1.next(); !locationsList_1_1.done; locationsList_1_1 = locationsList_1.next()) {
                            var location_1 = locationsList_1_1.value;
                            if (location_1.key === locationRuleId) {
                                location_1.isSelected = true;
                                location_1.isDisabled = isDeleteLocked;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (locationsList_1_1 && !locationsList_1_1.done && (_b = locationsList_1.return)) _b.call(locationsList_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // add a generic constraint to prevent the block from being deleted
            if (hasConstrainedSubBlock)
                updateUiBlock(__assign(__assign({}, uiBlock), { predicateConstraint: {
                        isHidden: false,
                        isReadOnly: true,
                    } }));
        }
    }, [locations]);
    useEffect(function () {
        getAtLeastOneLocationSelected();
    }, [locationsList]);
    var _k = __read(useState(false), 2), showSidePanel = _k[0], setShowSidePanel = _k[1];
    var _l = __read(useState(initLocationPayload), 2), locationPayload = _l[0], setLocationPayload = _l[1];
    useEffect(function () {
        if (showLocationSnackbar) {
            var ruleSidePanelBody = document.querySelector('.rule-builder-side-panel__body');
            ruleSidePanelBody.scrollTop = ruleSidePanelBody.scrollHeight;
        }
    }, [showLocationSnackbar]);
    var saveLocationCallback = useCallback(function (saveStatusInfo) {
        if (saveStatusInfo && saveStatusInfo.status === SAVE_LOCATION_STATUSES.ERROR) {
            setLocationSnackbarType(SAVE_LOCATION_STATUSES.ERROR);
            setLocationSnackbarMessage(saveStatusInfo.statusMessage || 'Location could not be saved!');
            setShowLocationSnackbar(true);
        }
        else {
            // ToDo - The side panel will be kept open if users want to edit the location right after creating it
            setLocationPayload(initLocationPayload);
            setShowSidePanel(false);
        }
    }, []);
    var handleSaveLocation = useCallback(function () {
        var _a, _b;
        var ruleSidePanelBody = document.querySelector('.rule-builder-side-panel__body');
        if (locationPayload) {
            if (!locationPayload.name) {
                setLocationSnackbarMessage('Enter a name');
                setShowLocationSnackbar(true);
                ruleSidePanelBody.scrollTop = ruleSidePanelBody.scrollHeight;
            }
            else if (isUniqueLocationNameError) {
                setLocationSnackbarMessage('Location name is not unique');
                setShowLocationSnackbar(true);
                ruleSidePanelBody.scrollTop = ruleSidePanelBody.scrollHeight;
            }
            else if (((_b = (_a = locationPayload.shape) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.length) <= 0) {
                setLocationSnackbarMessage('Create a shape');
                setShowLocationSnackbar(true);
                ruleSidePanelBody.scrollTop = ruleSidePanelBody.scrollHeight;
            }
            else {
                onSaveLocation(locationPayload, saveLocationCallback);
                setLocationSnackbarMessage('');
                setShowLocationSnackbar(false);
            }
        }
        else {
            setLocationSnackbarMessage('Enter name');
            setShowLocationSnackbar(true);
            ruleSidePanelBody.scrollTop = ruleSidePanelBody.scrollHeight;
        }
    }, [locationPayload, onSaveLocation, saveLocationCallback, isUniqueLocationNameError]);
    var sidePanelProps = {
        show: showSidePanel,
        theme: RB_SIDE_PANEL_THEMES.DEFAULT,
        headerInfo: {
            title: 'New Location',
            icon: React.createElement(LocationHeaderIcon, null),
        },
        footerInfo: {
            primaryActionText: 'Create Location',
            primaryActionHandler: handleSaveLocation,
            isPrimaryActionInProgress: isLocationSaving,
            secondaryActionText: 'Cancel',
            secondaryActionHandler: function () {
                setShowLocationSnackbar(false);
                setLocationSnackbarMessage('');
                setUniqueLocationNameError(false);
                setLocationPayload(initLocationPayload);
                setShowSidePanel(false);
            },
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RuleFrame, { renderProps: __assign({}, mapBlockToRuleFrameProps(renderProps)) },
            React.createElement("div", { className: "rule-children" },
                React.createElement(FlightSelect, { width: "100px", className: "rule-children__item", options: [{ key: 'boolEq', name: 'Is' }], selected: { key: 'boolEq', name: 'Is' } }),
                React.createElement(FlightSelectMulti, { autoFocus: true, isSearchEnabled: true, className: "rule-children__item", width: "350px", label: "Select a location", searchPlaceholder: "Search", options: locationsForMultiSelect, handleSearch: updateLocationsOnSearch, handleOptionSelect: updateLocationsListUiBlock, onClickOutsideParent: getAtLeastOneLocationSelected, hasError: showError, errorMessage: "Select one location" }),
                !hideAddNewLocationCTA && (React.createElement("div", { className: "rule-children__cta-container" },
                    React.createElement(FlightButton, { theme: "link", size: "large", iconLeft: "mathPlus", label: "New location", ariaLabel: "open add new location panel", onClick: function () { return setShowSidePanel(true); } }))),
                areLocationsWaiting && (React.createElement("div", { className: "rule-children__label" },
                    React.createElement(ViewBoxLoader, null))))),
        React.createElement(RuleBuilderSidePanel, __assign({}, sidePanelProps),
            React.createElement(GoogleMapWrapper, { apiKey: googleMapAPIKey, version: 'weekly', libraries: ['places', 'geometry'] },
                React.createElement(ManageLocation, { locationPayload: locationPayload, contextLabels: contextLabels, locationLabels: labelsForAddNewLocation, locations: locations, setLocationPayload: setLocationPayload, isUniqueLocationNameError: isUniqueLocationNameError, setUniqueLocationNameError: setUniqueLocationNameError, setShowLocationSnackbar: setShowLocationSnackbar, setLocationSnackbarMessage: setLocationSnackbarMessage })),
            React.createElement(FlightSnackbar, { className: "create-location-snack-bar", type: locationSnackbarType, isVisible: showLocationSnackbar, isFloating: false, action: null, content: locationSnackbarMessage, handleClose: function () { return setShowLocationSnackbar(false); } }))));
}
export default LocationsList;
//# sourceMappingURL=LocationsList.js.map